import LazyLoad from 'vanilla-lazyload'
const $ = require('jquery')
import { goBarba } from './barba_setup';
import { gsap } from "gsap";
// https://greensock.com/scrolltoplugin/
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

$.expr[':'].external = function(obj){
    return !obj.href.match(/^mailto\:/)
           && (obj.hostname != location.hostname)
           && !obj.href.match(/^javascript\:/)
           && !obj.href.match(/^$/)
};

const mainContentForTouch = false
const $html = $('html')
const $body = $('body')
const $window = $(window)
const $document = $(document)

let scrollLockPosition = null

let lazyLoadInstance = null
const lazyLoadInstanceInit = function() {
  // https://github.com/verlok/lazyload#-api
  lazyLoadInstance = new LazyLoad({
      callback_loaded: (el)=>{
        // masonry.update()
        appUtils.$window.trigger('image_loaded', el)
      },
      elements_selector: '.lazy',
      load_delay: 300 //adjust according to use case
  });
}


const appUtils = {
  navigationToggleClass: 'navigation-panel--open',
  lazyLoadInstanceInit: lazyLoadInstanceInit,
  mainContentForTouch: mainContentForTouch,
  $navBox: $('[data-navigation-box]'), // side navigation links
  $document: $document,
  $html: $html,
  $body: $body,
  $window: $window,
  isTouch: function () {
    if(typeof(Modernizr) === 'object'){
      return (Modernizr.touchevents)
    }else{
      // return (('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch) || window.navigator.msPointerEnabled)
      // return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))
      return (
        !!(typeof window !== 'undefined' &&
          ('ontouchstart' in window ||
            (window.DocumentTouch &&
              typeof document !== 'undefined' &&
              document instanceof window.DocumentTouch))) ||
        !!(typeof navigator !== 'undefined' &&
          (navigator.maxTouchPoints || navigator.msMaxTouchPoints))
      )
    }
  },
  isIos: function () {
    // return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
  },
  isPortrait: function () {
    // when keaborad is open, poprtrait smartphone became landscape! prevent this!
    return (window.innerWidth < window.innerHeight) || (window.innerWidth < 992)
  },

  // Bootstrap 4 breakpoints
  isXs: function () {
    return window.innerWidth < 576
  },
  isSm: function () {
    return window.innerWidth >= 576
  },
  isMd: function () {
    return window.innerWidth >= 768
  },
  isLg: function () {
    return window.innerWidth >= 992
  },
  isXl: function () {
    return window.innerWidth >= 1200
  },
  lazyUpdate: function(){
    if (lazyLoadInstance) {
        lazyLoadInstance.update()
    }
  },
  headerHeight: function() {
    // return $('header.main-header').height()
    return 0;
  },
  scrollTo: function(selector, offset, duration = 1.4 ){

    let scrollDestination = 0
    let scrollDestinationX = 0
    let dataScrollOffset = null
    if (typeof(selector) === 'string') {
      const $destination = $(selector)
      if ($destination.length) {
        const destinationOffset = $destination.offset()
        scrollDestination = destinationOffset.top
        scrollDestinationX = destinationOffset.left
        dataScrollOffset = ($destination.attr('data-scroll-offset')) ? parseInt($destination.attr('data-scroll-offset'), 10) : null
      }
    } else if (typeof(selector) === 'number') {
      scrollDestination = selector
    } else if (typeof(selector) === 'object') {
      if (selector.length) {
        scrollDestination = selector.offset().top
      }
    }

    if(typeof(offset) !== 'number'){
      offset = (dataScrollOffset !== null) ? dataScrollOffset : appUtils.headerHeight()
    }
    if(scrollDestination && mainContentForTouch && appUtils.isTouch()) {
      // $('.page-wrapper').animate({
      //   scrollTop: scrollDestination - offset,
      //   scrollLeft: scrollDestinationX
      // }, duration * 1000)
      gsap.to($('.page-wrapper'), {ease: 'power3', duration: duration, scrollTo: parseInt(scrollDestination - offset, 10)})
    } else {
      /*
      appUtils.$window.animate({
        scrollTop: scrollDestination - offset,
        scrollLeft: scrollDestinationX
      }, duration * 1000)
      */
      gsap.to(window, {
        duration: duration,
        scrollTo: parseInt(scrollDestination, 10) - offset,
      })
    }
  },

  // https://stackoverflow.com/questions/6238351/fastest-way-to-detect-external-urls
  checkDomain: function(url) {
    if ( url.indexOf('//') === 0 ) { url = location.protocol + url; }
    return url.toLowerCase().replace(/([a-z])?:\/\//,'$1').split('/')[0];
  },
  isExternal: function(url) {
    return ( ( url.indexOf(':') > -1 || url.indexOf('//') > -1 ) && appUtils.checkDomain(location.href) !== appUtils.checkDomain(url) );
  },
  goTo: function(url) {
    if (appUtils.isExternal(url)) {
      if ( (url.indexOf('|modal')!== -1) && typeof(appUtils.openIframeModal) === 'function') {
        appUtils.openIframeModal(url.replace('|modal', ''))
      } else {
        window.open(url)
      }
    } else {
      goBarba(url)
    }
  },
  // Iframe modal
  openIframeModal: function(iframeSrc) {
    const modalMarkup = '<div class="modal fade" id="modalIframe" tabindex="-1" role="dialog" aria-labelledby="modalIframeTitle" aria-hidden="true">' +
      '<div class="modal-close">' +

      '<button type="button" class="btn btn--burger btn--burger-close" data-dismiss="modal" aria-label="Close">' +
      '  <span class="burguer-wrapper">' +
      '    <span class="burger-line burger-line-1"></span>' +
      '    <span class="burger-line burger-line-2"></span>' +
      '    <span class="burger-line burger-line-3"></span>' +
      '  </span>' +
      '</button>' +

      '</div>' +
      '<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-iframe" role="document">' +
        '<div class="modal-content">' +
          '<div class="embed-responsive embed-responsive-16by9">' +
              '<iframe class="embed-responsive-item" src="' + iframeSrc + '" allow="autoplay; encrypted-media" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>'
    $body.append(modalMarkup)

    setTimeout(()=>{
      $('#modalIframe').on('show.bs.modal', function (e) {
        $body.addClass('modal-open--scroll-unlock')
      }).on('hidden.bs.modal', function (e) {
        $body.removeClass('modal-open--scroll-unlock')
        $('#modalIframe').remove()
      }).modal('show')
    }, 0)
  },

  /*
  * App utility to append script to document body
  */
  addedScripts: [],
  addScript: function( src, callback ) {
    if (appUtils.addedScripts.indexOf(src) === -1) {
      appUtils.addedScripts.push(src)
      var s = document.createElement( 'script' )
      s.setAttribute( 'src', src )
      s.onload=callback
      //document.querySelector('#barba-wrapper .barba-container').appendChild( s )
      document.body.appendChild( s )
    } else {
      callback()
    }
  },

  progressBarrSelector: '#progress-bar',

  triggerEvent: function(eventName, args) {
    $window.trigger(eventName, args)
  },

  scrollLock: function(scrollPosition) {
    if (scrollPosition) {
      scrollLockPosition = scrollPosition
    } else {
      scrollLockPosition = [
        self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
        self.pageYOffset || document.documentElement.scrollTop  || document.body.scrollTop
      ]
    }
    appUtils.$html.css('overflow', 'hidden')
    window.scrollTo(scrollLockPosition[0], scrollLockPosition[1])
    // appUtils.$html.addClass('scroll-lock')
  },
  scrollUnlock: function(backToPreviousPosition=true) {
    appUtils.$html.css('overflow', '') // 'visible'
    if (scrollLockPosition !== null && backToPreviousPosition) {
      window.scrollTo(scrollLockPosition[0], scrollLockPosition[1])
    }
    // appUtils.$html.removeClass('scroll-lock')
  },
  overlayOn: function() {
    appUtils.$html.addClass('overlay-on')
  },
  overlayOff: function() {
    appUtils.$html.removeClass('overlay-on')
  },
  bgLogo: document.querySelectorAll('[data-logo-item]'),
  bgLogoTo: function(params) {
    if (appUtils.bgLogoAnimation) {
      appUtils.bgLogoAnimation.kill() //.progress(1)
    }
    appUtils.bgLogoAnimation = gsap.to(appUtils.bgLogo, {...params, duration: 1, stagger: 0.1})
  }
}

export default appUtils
